import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import Link from "next/link";
import { toast } from "react-hot-toast";
import {
  AppliedCartOffers,
  setCartAddedAddons,
  setCartAddedPackages,
  setCartJobItems,
  setCartProducts,
  setCartStage,
  setCartWorkshop,
  setShowMobileIstand,
} from "../../../redux/actions/cartAction";
import { resetCart, saveCart } from "../../../lib/cart";
import { gtm_ecommerce_remove_from_cart } from "lib/GA4_tag";
import { getCategory, getVariants } from "../../../redux/actions/apiActions";
import { setLayer, setLoader } from "redux/actions/globalAction";
import router from "next/router";

function EmptyCartModal({
  show,
  onHide,
  title,
  message,
  setCartJobItems,
  setCartProducts,
  setCartStage,
  setCartWorkshop,
  setCartAddedAddons,
  cart,
  apiData,
  globalData,
  getCategory,
  id,
  getVariants,
  setCartAddedPackages,
  setShowMobileIstand,
  setLayer,
  setLoader,
  AppliedCartOffers,
}) {
  const handleConfirmChange = async () => {
    setLoader(true);
    localStorage.removeItem("tyreProduct");
    sessionStorage.removeItem("get-fitting-at-home");
    localStorage.removeItem("obWorkshop");
    setCartStage(null);
    setCartProducts([]);
    setCartJobItems([]);
    setCartAddedAddons([]);
    setCartAddedPackages([]);
    setShowMobileIstand(false);
    setCartWorkshop(null);
    getCategory();
    sessionStorage.removeItem("isWorkshopCollection");
    setLayer(false);
    onHide();
    AppliedCartOffers(null);
    getVariants(id, globalData?.carData?.modelId);
    saveCart(cart, apiData, globalData, true);
    await resetCart();

    if (cart?.jobItems?.length) {
      RemoveFromCartEvent(cart?.jobItems[0]);
    }
    // let category = "oil-change";
    // const querySlug = router.query?.slug;
    // if (querySlug.length >= 2) {
    //   category = querySlug[1];
    // }
    // window.location.href =
    //   window.location.origin +
    //   `/services/${
    //     globalData.locationData?.data.EmirateAreaSlug || "dubai"
    //   }/${category}`;
  };
  const RemoveFromCartEvent = (item) => {
    let offer;
    const isOfferApplied =
      cart.appliedCartOffers?.variantId == item?.JourneyVariantId;
    if (isOfferApplied) {
      offer = item?.Offers.filter(
        (e) => e.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }

    const event = {
      currency: "AED",
      value: item.Cost,
      items: [
        {
          item_id: item.JourneyVariantId,
          item_name: item.JourneyVariantName,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          // discount: variant.DiscountedCost || 0,
          // item_category: filterCategory[0].Name,
          // item_list_id: filterCategory[0].ID,
          // item_list_name: filterCategory[0].Name,
          price: item.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_remove_from_cart(event);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleConfirmChange}>
          Yes
        </Button>
        <Button variant="secondary" onClick={onHide}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    loginData: state.loginData,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (jobs) => {
      dispatch(setCartJobItems(jobs));
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setCartAddedAddons: (addons) => {
      dispatch(setCartAddedAddons(addons));
    },
    getCategory: () => {
      dispatch(getCategory());
    },
    getVariants: (id, Mid) => {
      dispatch(getVariants(id, Mid));
    },
    setCartAddedPackages: (packages) => {
      dispatch(setCartAddedPackages(packages));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setLoader: (status) => {
      dispatch(setLoader(status));
    },
    setShowMobileIstand: (status) => {
      dispatch(setShowMobileIstand(status));
    },
    AppliedCartOffers: (data) => {
      dispatch(AppliedCartOffers(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmptyCartModal);
